export default __webpack_public_path__ + "static/media/feature-editor.0ff449f9.webp";